<template lang='pug'>
  .fpui-step(v-show='isActive()')
    slot
</template>

<script>

export default {
  props: {
    header: { type: String, required: true },
    validate: { type: Function }
  },
  data () {
    return {
      index: null
    }
  },
  methods: {
    isActive () { return this.$parent.isActive(this.index) }
  }
}
</script>

<style lang="less">

.fpui-step {
  padding: 10px;
}

</style>
